import * as Yup from 'yup';

import { timeBoundValuesSectionSchema } from '../Sections/TimeBoundValuesSection/utils/timeBoundValuesSectionSchema';

import { defaultSectionSchema } from '../Sections/DefaultSectionSchema';
import { employeePortalSectionSchema } from '../Sections/EmployeePortalSection.consts';

export const schema = Yup.object().shape({
  ...defaultSectionSchema.fields,
  ...timeBoundValuesSectionSchema.fields,
  ...employeePortalSectionSchema.fields
});
